// Public surface of the navigation registry.
export { REGISTRY, getEntryById } from './registry'
export { SECTIONS, SUBCONTRACTOR_MENU, getSectionById, getSectionTitle } from './sections'
export {
  buildNavContext,
  getEntryAccess,
  getNavAccess,
  canSeeUpgradeLocks,
} from './visibility'
export { getNavIcon } from './icons'

import { REGISTRY, getEntryById } from './registry'

// Resolve a pathname to its registry entry: exact match first, then the
// longest entry path that is a parent of it (so /fleet/abc123 resolves to the
// Vehicles entry). Returns undefined for unregistered paths.
export const getEntryByPath = (pathname) => {
  if (!pathname) return undefined
  const clean = pathname !== '/' ? pathname.replace(/\/+$/, '') : '/'
  let best
  for (const entry of REGISTRY) {
    if (entry.path === clean) return entry
    if (
      entry.path !== '/' &&
      clean.startsWith(`${entry.path}/`) &&
      (!best || entry.path.length > best.path.length)
    ) {
      best = entry
    }
  }
  return best
}

// Href of the knowledgebase article explaining a page, or undefined.
export const getDocsHref = (registryId) => {
  const articleId = getEntryById(registryId)?.docs?.articleId
  return articleId ? `/docs/${articleId}` : undefined
}
